export default "__VITE_ASSET__O$iRcUbU__"